import { Box, makeStyles, Typography } from '@material-ui/core';

type Props = {
  title: string;
  body: string;
};

export const EmptyData = ({ title, body }: Props) => {
  const classes = useStyles();
  return (
    <Box className={classes.emptyState}>
      <Typography className={classes.emptyStateTitle}>{title}</Typography>
      <Typography className={classes.emptyStateBody}>{body}</Typography>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  emptyState: {
    border: `1px dashed ${theme.palette.border}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
  },
  emptyStateTitle: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
  },
  emptyStateBody: {
    fontSize: '0.88rem',
    lineHeight: 1.45,
  },
}));
